var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "form-field" }, [
    _vm.element === "input"
      ? _c("input", {
          ref: "element",
          class: [
            "form-field__element",
            {
              "form-field__element--empty": _vm.isEmpty,
              "form-field__element--invalid": _vm.invalid
            }
          ],
          attrs: {
            type: _vm.type,
            name: _vm.name,
            required: _vm.required,
            placeholder: " "
          },
          on: { input: _vm.onInput, blur: _vm.onBlur }
        })
      : _vm._e(),
    _vm.element === "textarea"
      ? _c("textarea", {
          ref: "element",
          class: [
            "form-field__element",
            {
              "form-field__element--empty": _vm.isEmpty,
              "form-field__element--invalid": _vm.invalid
            }
          ],
          attrs: { name: _vm.name, required: _vm.required },
          on: { input: _vm.onInput, blur: _vm.onBlur }
        })
      : _vm._e(),
    _vm.element === "select"
      ? _c(
          "select",
          {
            ref: "element",
            class: [
              "form-field__element",
              { "form-field__element--invalid": _vm.invalid }
            ],
            attrs: { name: _vm.name, required: _vm.required },
            on: { input: _vm.onInput, blur: _vm.onBlur }
          },
          _vm._l(_vm.options, function(option) {
            return _c("option", { domProps: { value: option.code } }, [
              _vm._v("\n\t\t\t" + _vm._s(option.title) + "\n\t\t")
            ])
          }),
          0
        )
      : _vm._e(),
    _vm.label
      ? _c("span", { staticClass: "form-field__label" }, [
          _vm._v(_vm._s(_vm.label))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e798cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e798cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FormField.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-05e798cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FormField.vue
// module chunks = 0 1 2